import { FC, ReactNode, useEffect, useState } from 'react';

import classNames from 'classnames';

import HSpacing from 'bloko/blocks/hSpacing';
import Icon, { IconColor, IconLink, IconScale, IconView } from 'bloko/blocks/icon';
import InputText, { InputScale } from 'bloko/blocks/inputText';

import 'components/Admin/Reports/ActsReport/EditingActsTable/EditingAct/EditingField/EditingField.less';

interface EditingFieldProps {
    value: string | number;
    newValue: string | undefined;
    setNewValue: (value: string) => void;
    resetNewValue: () => void;
    children: ReactNode;
    size?: 'small' | 'medium';
    placeholder?: string;
}

const EditingField: FC<EditingFieldProps> = ({
    value,
    newValue,
    setNewValue,
    resetNewValue,
    children,
    size,
    placeholder,
}) => {
    const [isEditing, setEditing] = useState(false);

    useEffect(() => {
        if (value && newValue === undefined) {
            setEditing(false);
        }
    }, [value, newValue]);

    if (isEditing) {
        return (
            <div
                className={classNames('acts-editing-field', {
                    'acts-editing-field-small': size === 'small',
                    'acts-editing-field-medium': size === 'medium',
                })}
            >
                <InputText
                    value={newValue === undefined ? value || '' : newValue}
                    onChange={setNewValue}
                    scale={InputScale.Small}
                    placeholder={placeholder}
                />
                <HSpacing base={2} />
                {value !== null && (
                    <IconLink
                        onClick={() => {
                            resetNewValue();
                            setEditing(false);
                        }}
                    >
                        <Icon view={IconView.Cross} initial={IconColor.Gray50} scale={IconScale.Small} />
                    </IconLink>
                )}
            </div>
        );
    }

    return (
        <div
            className={classNames('acts-editing-field', {
                'acts-editing-field-small': size === 'small',
                'acts-editing-field-medium': size === 'medium',
            })}
        >
            {children}
            <HSpacing base={2} />
            <IconLink onClick={() => setEditing(true)}>
                <Icon view={IconView.PenSquare} initial={IconColor.Gray50} scale={IconScale.Small} />
            </IconLink>
        </div>
    );
};

export default EditingField;
